interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '17c 平台',
      url: 'https://www.17c.com',
      description: '17c 平台是一个综合性的数字化服务平台，致力于为用户提供便捷、高效、安全的在线服务体验。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-8888',
        contactType: 'customer service',
        email: 'support@17c.com',
        availableLanguage: ['Chinese'],
      },
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'http //www.17c/ 官方入口与使用指南',
      url: 'https://www.17c.com',
      description: 'http //www.17c/ 官方入口与使用指南，提供完整的访问指引、功能介绍与使用说明。',
      inLanguage: 'zh-CN',
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'http //www.17c/ 官方入口与使用指南',
      description: 'http //www.17c/ 官方入口与使用指南，提供完整的访问指引、功能介绍与使用说明。',
      inLanguage: 'zh-CN',
      isPartOf: {
        '@type': 'WebSite',
        name: '17c 平台',
        url: 'https://www.17c.com',
      },
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      inLanguage: 'zh-CN',
      publisher: {
        '@type': 'Organization',
        name: '17c 平台',
        url: 'https://www.17c.com',
      },
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = schemas[type];
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}